import React from "react";
import { MapPin, Clock, Phone, Mail } from "lucide-react";
import { company } from "../data/mock";

export default function TopBar() {
  return (
    <div className="brand-navy text-white text-xs md:text-sm">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-2.5 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-5">
          <div className="flex items-center gap-2">
            <MapPin size={14} className="text-brand-red" />
            <span>{company.location}</span>
          </div>
          <a href={`mailto:${company.email}`} className="hidden md:flex items-center gap-2 hover:text-brand-red transition-colors">
            <Mail size={14} />
            <span>{company.email}</span>
          </a>
        </div>
        <div className="flex items-center gap-5">
          <div className="flex items-center gap-2">
            <Clock size={14} className="text-brand-red" />
            <span>{company.workingHours}</span>
          </div>
          <a href={`tel:${company.phoneRaw}`} className="hidden md:flex items-center gap-2 hover:text-brand-red transition-colors">
            <Phone size={14} />
            <span>{company.phone}</span>
          </a>
        </div>
      </div>
    </div>
  );
}
